import { render, staticRenderFns } from "./qr-code-render.vue?vue&type=template&id=6241c4cd"
import script from "./qr-code-render.vue?vue&type=script&lang=js"
export * from "./qr-code-render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports